import { Row } from './types';
import { sumColumns } from '../common';
import { Link } from 'react-router-dom';
import { TableColumns } from '@ff-it/ui';
import { ClientTitle } from 'components';

export const columns: TableColumns<Row> = [
  {
    content: 'Agency',
    key: 'enterprise_slug',
    width: 80,
  },
  {
    content: 'Client',
    key: 'client_internal_name',
    sortable: true,
    render: ({ client_internal_name, payer_internal_name }) => (
      <ClientTitle
        client={{
          internal_name: client_internal_name,
        }}
        payer={{
          internal_name: payer_internal_name,
        }}
      />
    ),
  },
  {
    content: 'Brand',
    key: 'brand_title',
    sortable: true,
  },
  {
    content: 'Campaign',
    key: 'campaign_title',
    sortable: true,
    render: ({ enterprise_slug, campaign_id, campaign_title }) => (
      <Link to={`/${enterprise_slug}/planning/campaigns/${campaign_id}/planning`}>{campaign_title}</Link>
    ),
  },
  ...sumColumns,
];
